import React from 'react';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';

/**
 * SelectionPointのProps
 */
interface SelectionPointProps {
  /** 選考のポイント */
  selectionPoint: string;
}

/**
 * 選考のポイントを表示するコンポーネント
 *
 * @param {string} props.selectionPoint - 選考のポイント
 */
export const SelectionPoint: React.FC<SelectionPointProps> = ({
  selectionPoint,
}) => {
  return (
    <SectionItem label="選考のポイント">
      <TextWithLF text={selectionPoint} />
    </SectionItem>
  );
};
